/**
 * Plan C predictive search: keep Troop's section-rendering client,
 * expand Shopify match fields, and fill debounce / IME / a11y gaps.
 * Does not call search/suggest.json and does not re-rank results.
 */
(function () {
  if (window.__bbPredictiveSearch) return;
  window.__bbPredictiveSearch = true;

  var DEBOUNCE_MS = 200;
  var CACHE_LIMIT = 24;
  var FIELDS = 'title,product_type,tag,body,variants.title,variants.sku,vendor';
  var RESOURCE_TYPES = 'product,query,collection,page';

  patchFetch();
  whenPredictiveReady(enhanceAll);
  window.addEventListener('theme:drawer:open', onDrawerOpen);
  window.addEventListener('theme:drawer:top:closing', abortAll);

  function predictivePath() {
    var routes = window.Shopify && window.Shopify.routes;
    return (routes && routes.predictive_search) || '/search/suggest';
  }

  function isPredictiveUrl(url) {
    if (!url) return false;
    return url.indexOf('/search/suggest') !== -1 || url.indexOf(predictivePath()) !== -1;
  }

  function enrichUrl(url) {
    var next = new URL(url, window.location.origin);
    if (!next.searchParams.get('section_id')) {
      next.searchParams.set('section_id', 'predictive-search');
    }
    if (next.searchParams.get('resources[options][fields]')) return next.toString();
    next.searchParams.set('resources[type]', RESOURCE_TYPES);
    next.searchParams.set('resources[limit]', '10');
    next.searchParams.set('resources[limit_scope]', 'each');
    next.searchParams.set('resources[options][unavailable_products]', 'last');
    next.searchParams.set('resources[options][fields]', FIELDS);
    return next.toString();
  }

  function patchFetch() {
    var original = window.fetch;
    if (original.__bbPredictive) return;
    function wrapped(input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && isPredictiveUrl(url) && url.indexOf('suggest.json') === -1) {
          var enriched = enrichUrl(url);
          if (enriched !== url) {
            input = typeof input === 'string' ? enriched : new Request(enriched, input);
          }
        }
      } catch (err) {}
      return original.call(this, input, init);
    }
    wrapped.__bbPredictive = true;
    window.fetch = wrapped;
  }

  function whenPredictiveReady(callback) {
    if (window.customElements && customElements.get('predictive-search-element')) {
      callback();
      return;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('predictive-search-element').then(callback);
    }
  }

  function onDrawerOpen(event) {
    if (!event.detail || event.detail.view !== 'search') return;
    whenPredictiveReady(function () {
      enhanceAll();
      var input = document.getElementById('search_input');
      if (input) input.focus();
    });
  }

  function abortAll() {
    document.querySelectorAll('predictive-search-element').forEach(function (el) {
      if (el._bbTimer) {
        clearTimeout(el._bbTimer);
        el._bbTimer = null;
      }
      el._bbSearchSeq = (el._bbSearchSeq || 0) + 1;
      if (el.abort_controller) el.abort_controller.abort();
      setExpanded(el, false);
    });
  }

  function enhanceAll() {
    var Proto = customElements.get('predictive-search-element');
    if (Proto && Proto.prototype && !Proto.prototype.__bbPatched) {
      patchPrototype(Proto.prototype);
    }
    document.querySelectorAll('predictive-search-element').forEach(bindElement);
  }

  function patchPrototype(proto) {
    proto.__bbPatched = true;
    proto.addInputListener = function () {
      bindElement(this);
    };
    proto.getSearchResults = function (term) {
      return runSearch(this, term);
    };
  }

  function rememberCache(el, key, html) {
    if (!el.cached_results) el.cached_results = new Map();
    el.cached_results.set(key, html);
    if (el.cached_results.size <= CACHE_LIMIT) return;
    el.cached_results.forEach(function (_value, cachedKey) {
      if (el.cached_results.size <= CACHE_LIMIT) return;
      if (cachedKey !== '') el.cached_results.delete(cachedKey);
    });
  }

  function runSearch(el, term) {
    if (el.abort_controller) el.abort_controller.abort();
    var query = String(term || '').trim();
    if (el.cached_results && el.cached_results.has(query)) {
      el.results.innerHTML = el.cached_results.get(query);
      if (el.toggleLoading) el.toggleLoading(false);
      return Promise.resolve();
    }

    if (!query) {
      if (el.toggleLoading) el.toggleLoading(false);
      return Promise.resolve();
    }

    el.abort_controller = new AbortController();
    el._bbSearchSeq = (el._bbSearchSeq || 0) + 1;
    var seq = el._bbSearchSeq;
    if (el.toggleLoading) el.toggleLoading(true);

    var params = new URLSearchParams({
      q: query,
      section_id: 'predictive-search',
      'resources[type]': RESOURCE_TYPES,
      'resources[limit]': '10',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': FIELDS
    });

    return fetch(predictivePath() + '?' + params.toString(), {
      signal: el.abort_controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('search');
        return response.text();
      })
      .then(function (text) {
        if (seq !== el._bbSearchSeq) return;
        var html = typeof text.parse === 'function' ? text.parse().innerHTML : parseSection(text);
        rememberCache(el, query, html);
        el.results.innerHTML = html;
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (el.toggleLoading) el.toggleLoading(false);
      });
  }

  function parseSection(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var section = doc.querySelector('#shopify-section-predictive-search') || doc.body.firstElementChild;
    return section ? section.innerHTML : '';
  }

  function bindElement(el) {
    if (el.__bbBound) return;
    var input = el.input || el.querySelector('.search--textbox');
    var results = el.results || el.querySelector('.search--results');
    if (!input || !results) return;
    el.__bbBound = true;
    el.input = input;
    el.results = results;
    el.clear_button = el.clear_button || el.querySelector('.search--clear');
    if (!el.cached_results) el.cached_results = new Map([['', results.innerHTML]]);

    if (typeof input.off === 'function') input.off('input');

    var composing = false;

    input.addEventListener('compositionstart', function () {
      composing = true;
    });
    input.addEventListener('compositionend', function () {
      composing = false;
      schedule(el);
    });
    input.addEventListener('input', function () {
      if (composing) return;
      schedule(el);
    });
    input.addEventListener('keydown', function (event) {
      onKeydown(el, event);
    });

    if (!el.__bbStatusObserver) {
      el.__bbStatusObserver = new MutationObserver(function () {
        announce(el);
        setActive(el, -1);
      });
      el.__bbStatusObserver.observe(results, { childList: true });
    }

    input.setAttribute('aria-haspopup', 'listbox');
    setExpanded(el, false);
  }

  function schedule(el) {
    var query = el.input.value.trim();
    if (el.clear_button) el.clear_button.setAttribute('aria-hidden', query === '' ? 'true' : 'false');
    if (el._bbTimer) {
      clearTimeout(el._bbTimer);
      el._bbTimer = null;
    }
    if (!query) {
      el._bbSearchSeq = (el._bbSearchSeq || 0) + 1;
      if (el.abort_controller) el.abort_controller.abort();
      setExpanded(el, false);
      el.getSearchResults('');
      return;
    }
    el._bbTimer = setTimeout(function () {
      var viewport = document.querySelector('.layout--viewport');
      if (viewport && (viewport.getAttribute('data-drawer-status') === 'closed' || viewport.getAttribute('data-drawer-view') !== 'search')) {
        return;
      }
      if (el.input.value.trim() !== query) return;
      setExpanded(el, true);
      el.getSearchResults(query);
    }, DEBOUNCE_MS);
  }

  function optionsOf(el) {
    return Array.prototype.slice.call(el.querySelectorAll('[role="option"]'));
  }

  function onKeydown(el, event) {
    var options = optionsOf(el);
    if (!options.length) return;
    var key = event.key;
    var current = options.findIndex(function (option) {
      return option.getAttribute('aria-selected') === 'true';
    });

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      event.preventDefault();
      var delta = key === 'ArrowDown' ? 1 : -1;
      var next = current < 0 ? (delta > 0 ? 0 : options.length - 1) : (current + delta + options.length) % options.length;
      setActive(el, next);
      return;
    }

    if (key === 'Enter' && current >= 0) {
      var link = options[current].querySelector('a[href]');
      if (link) {
        event.preventDefault();
        window.location.href = link.href;
      }
    }
  }

  function setActive(el, index) {
    var options = optionsOf(el);
    options.forEach(function (option, optionIndex) {
      var selected = optionIndex === index;
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) option.scrollIntoView({ block: 'nearest' });
    });
    if (index >= 0 && options[index]) {
      el.input.setAttribute('aria-activedescendant', options[index].id);
    } else {
      el.input.removeAttribute('aria-activedescendant');
    }
  }

  function setExpanded(el, expanded) {
    el.input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function announce(el) {
    var status = document.getElementById('bb-search-status');
    if (!status) return;
    var query = el.input.value.trim();
    if (!query) {
      status.textContent = '';
      return;
    }
    var count = el.querySelectorAll('.predictive-search--product-grid .product-card--root').length;
    var template = status.getAttribute(count > 0 ? 'data-found' : 'data-empty') || '';
    status.textContent = template.replace('__COUNT__', String(count)).replace('{{ count }}', String(count));
  }
})();
